import { getImpersonatedPersonId } from "../../../../common/local-storage/impersonated-person";
import { getPreferredLanguage } from "../../../../common/local-storage/language";
import { getOrganizationId } from "../../../../common/local-storage/selected-organization";
import { sanitizeFilename } from "../../../../common/utils/sanitizeUtils";
import { requireStringEnvVar } from "../../../../config";

export const downloadSeV2QaReport = async ({ eventId, fileName }: { eventId: string; fileName: string }) => {
  const persistedOrganizationId = getOrganizationId();
  const impersonatedPersonId = getImpersonatedPersonId();
  const response = await fetch(`${requireStringEnvVar("VITE_BFF_BASE_URL")}/api/buyer/events/${eventId}/qa-report`, {
    method: "GET",
    credentials: "include",
    headers: {
      ...(persistedOrganizationId ? { organizationId: persistedOrganizationId } : undefined),
      ...(impersonatedPersonId ? { personId: impersonatedPersonId } : undefined),
      "preferred-language": getPreferredLanguage(),
    },
  });

  if (!response.ok) throw Error("Failed to download QA report");

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${sanitizeFilename(`${fileName}.pdf`)}`;
  document.body.appendChild(a);
  a.click();
};
